import { useEffect, useState } from 'react';
import { LoadingSpinner } from '../components/common/LoadingSpinner';

export const AuthCallback = () => {
  const [status, setStatus] = useState<string>('Processing...');

  useEffect(() => {
    const handleAuthCallback = async () => {
      console.log('AuthCallback: Processing OAuth callback...');
      setStatus('Reading token...');

      // Parse token from URL query string
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const returnUrl = params.get('return_url');

      console.log('AuthCallback: Token present:', !!token);
      console.log('AuthCallback: Return URL:', returnUrl);

      if (token) {
        // Store token in localStorage for the auth hook to use
        localStorage.setItem('auth_token', token);
        console.log('AuthCallback: Token stored in localStorage');
        setStatus('Token stored, verifying...');

        // Clear the URL query string for security
        window.history.replaceState(null, '', window.location.pathname);

        // Call verify endpoint directly to ensure token works
        try {
          const response = await fetch('/api/auth/verify', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });

          console.log('AuthCallback: Verify response:', response.status);

          if (response.ok) {
            const data = await response.json();
            console.log('AuthCallback: User verified:', data.user?.email);
            console.log('AuthCallback: User is_admin:', data.user?.is_admin);
            console.log('AuthCallback: Organization:', data.organization?.name);
            setStatus('Verified! Redirecting...');

            // Small delay to show success, then redirect
            setTimeout(() => {
              // Route admin users to /admin dashboard only when on the admin. subdomain.
              // Tenant subdomain admins (e.g. koshinko.smartcatalog.app) stay on their subdomain.
              let destination = returnUrl || '/';
              const isAdminUser = data.user?.is_admin;
              const isSystemOrg = data.organization?.name === 'system';

              if (isAdminUser || isSystemOrg) {
                try {
                  const targetHostname = returnUrl
                    ? new URL(returnUrl).hostname
                    : window.location.hostname;
                  const isAdminSubdomain = targetHostname.startsWith('admin.');
                  const parsedReturn = returnUrl ? new URL(returnUrl) : null;
                  const isRootPath = !parsedReturn || parsedReturn.pathname === '/';

                  if (isAdminSubdomain && isRootPath) {
                    destination = parsedReturn
                      ? `${parsedReturn.origin}/admin`
                      : '/admin';
                    console.log('AuthCallback: Admin subdomain + root path, redirecting to admin dashboard');
                  }
                } catch {
                  // Malformed URL — leave destination as-is
                }
              }
              console.log('AuthCallback: Redirecting to:', destination);
              window.location.href = destination;
            }, 500);
          } else {
            console.error('AuthCallback: Verify failed:', response.status);
            setStatus('Verification failed, redirecting to signin...');
            setTimeout(() => {
              window.location.href = '/signin';
            }, 1000);
          }
        } catch (err) {
          console.error('AuthCallback: Verify error:', err);
          setStatus('Error verifying token');
          setTimeout(() => {
            window.location.href = '/signin';
          }, 1000);
        }
      } else {
        // No token in URL
        console.log('AuthCallback: No token in URL');
        setStatus('No token found, redirecting...');
        setTimeout(() => {
          window.location.href = '/signin';
        }, 500);
      }
    };

    handleAuthCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-gray-600">{status}</p>
      </div>
    </div>
  );
};